import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { ListiniApi, GetListiniAnimaliDettagliRequest } from "../data/apis/ListiniApi";

export function listiniAnimaliDettaglioDataSource(idListinoTestata: number, showAll:boolean) {
    return new CustomStore({
        key: "id",
        loadMode : 'raw',
        load: (loadOptions) => {
            const api = new ListiniApi(apiConfiguration);

            const request: GetListiniAnimaliDettagliRequest = {
                idListinoTestata: idListinoTestata,
                showAll: showAll
            };

            return api.getListiniAnimaliDettagli(request);
        },

        byKey: (key) => {
            const api = new ListiniApi(apiConfiguration);

            return api.getListinoAnimaliDettaglioById({
                id: key
            });
        },

        insert: (values) => {
            const api = new ListiniApi(apiConfiguration);

            return api.insertListinoAnimaliDettaglio({
                idListinoTestata: idListinoTestata,
                listinoAnimaliDettaglioCreateDTO: values
            });
        },

        update: (key, values) => {
            const api = new ListiniApi(apiConfiguration);
            return api.updateListinoAnimaliDettaglio({
                id: key,
                listinoAnimaliDettaglioUpdateDTO: values
            });
        },

        remove: (key) => {
            const api = new ListiniApi(apiConfiguration);
            return api.deleteListinoAnimaliDettaglio({
                id: key,
            });
        }
    });
}